/* SCROLL DEPTH FOR GA4, Cajo (Josh, 2026-10-20: "yes" to named sections plus 10% steps).
   GA4's own scroll event fires once, at 90%. On a story page 30-40 phone screens long that
   says nothing about where people stop, so this sends two events, each once per page view:

   section_view  { section_name, section_index }  when a page section first crosses the middle
                 of the screen. The name is the section's key in its template ("hero", "tour",
                 "specs" ...), so GA4 can show "62% reached the tour, 31% reached specs".
                 Only template sections count: the header, footer and other shared groups don't.
   scroll_depth  { percent }  at 10, 20 ... 100% of the page, a fallback for pages whose
                 sections are not named usefully.

   Reads layout only inside one animation frame per scroll, so it never janks a scroll. Sends
   through gtag(), which queues in dataLayer until GA4 has loaded (layout/theme.liquid). */
(function () {
  if (typeof window.gtag !== 'function') return;
  var sections = [].slice.call(document.querySelectorAll('main [id^="shopify-section-template--"], [id^="shopify-section-template--"]'))
    .filter(function (el, i, all) { return all.indexOf(el) === i && el.offsetHeight > 0; });
  var seen = {}, sent = 0, queued = false;

  function name(el) {
    var id = el.id.replace('shopify-section-', '');
    var cut = id.lastIndexOf('__');
    return cut > -1 ? id.slice(cut + 2) : id;
  }

  function check() {
    queued = false;
    var mid = window.innerHeight / 2;
    for (var i = 0; i < sections.length; i++) {
      var el = sections[i], key = name(el);
      if (seen[key]) continue;
      var r = el.getBoundingClientRect();
      if (r.top < mid && r.bottom > mid) {
        seen[key] = true;
        gtag('event', 'section_view', { section_name: key, section_index: i + 1 });
      }
    }
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    var pct = max > 0 ? Math.floor(((window.scrollY || doc.scrollTop) / max) * 100) : 100;
    while (sent + 10 <= pct && sent < 100) {
      sent += 10;
      gtag('event', 'scroll_depth', { percent: sent });
    }
  }

  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(check);
  }

  addEventListener('scroll', onScroll, { passive: true });
  if (document.readyState === 'complete') check(); else addEventListener('load', check, { once: true });
})();
